module.exports = __webpack_public_path__ + "static/media/InterviewModeModerator.e58c5e0b.svg";